<template>
  <div class="wrapper">
    <noticeDetailNew></noticeDetailNew>
    <shareQRCode :code="code"></shareQRCode>
  </div>
</template>

<script>
import noticeDetailNew from "@/app/shop/components/noticeDetailNew.vue";
import shareQRCode from "@/app/shop/components/shareQRCode.vue";
import axios from "axios";
export default {
  name: "viewNoticeDetail",
  components: {
    noticeDetailNew,
    shareQRCode
  },
  data() {
    return {
      code: ""
    };
  },
  mounted() {
    // 如果URL中有noticeId参数，则调用分享二维码接口
    if (this.$route.query.noticeId) {
      this.shareQRCodeRequest();
    }
  },
  methods: {
    shareQRCodeRequest() {
      const apiUrl =
        "https://aimarket.iccec.cn/api-v2/tender-api/info-qr/share";
      const params = {
        scene: this.$route.query.noticeId,
        path: "pages/home/detail"
      };
      axios
        .post(apiUrl, params)
        .then(response => {
          if (response.data.code === 0) {
            this.code = response.data.data;
          }
        })
        .catch(error => {
          console.error("分享二维码请求失败:", error);
        });
    }
  }
};
</script>

<style scoped></style>
